<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 z-50 bg-white pt-5">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div
          class="w-5/5 mx-auto rounded-lg shadow-lg"
          style="background: #abb2b9; padding: 20px"
        >
          <div v-if="comments.length == 0">
            <span>No hay mensajes que mostrar</span>
          </div>
          <div v-for="comment in comments" :key="comment.id">
            <div class="flex flex-col">
              <!--comentario usuario actual-->
              <div
                class="relative flex flex-col mb-4 px-4 py-2 rounded-lg shadow-lg"
                style="background: #89d3c8; width: 80%; align-self: end"
                v-if="comment.usuario_id === uuid"
              >
                <div
                  v-if="comment.usuario_id === uuid"
                  class="w-full text-left text-xs text-gray-800"
                >
                  {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }}
                  <b>[yo]</b>
                </div>
                <div
                  v-if="comment.usuario_id === uuid"
                  class="w-full text-left text-gray-700"
                >
                  {{ comment.texto }}
                </div>
              </div>
              <!--comentario usuario actual-->

              <!--comentario curador -->
              <div
                class="relative flex flex-col mb-4 px-4 py-2 rounded-lg shadow-lg"
                style="background: #dee2ec; width: 80%; align-self: start"
                v-if="comment.usuario_id != uuid"
              >
                <div
                  v-if="comment.usuario_id == information.userficha_id"
                  class="w-full text-left text-xs text-gray-800"
                >
                  <b>[usuario]</b>
                  {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }}
                </div>
                <div
                  v-if="comment.usuario_id != information.userficha_id"
                  class="w-full text-left text-xs text-gray-800"
                >
                  <b>[revisor]</b>
                  {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }}
                </div>
                <div
                  v-if="comment.usuario_id !== uuid"
                  class="w-full text-left text-gray-700"
                >
                  {{ comment.texto }}
                </div>
              </div>
              <!--comentario curador -->
            </div>
          </div>
        </div>
        <div class="flex w-full sticky bottom-0 justify-center py-5 bg-white">
          <btn-action
            v-if="showNewMessageButton == true"
            v-on:click="updateStatusModal()"
            class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
            :colorT="colorT"
          >
            Enviar Mensaje
          </btn-action>
        </div>
      </div>
    </div>

    <user-raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllChat="fetchAllChat"
    ></user-raising-modal>
  </div>
</template>

<script>
import UserRaisingModal from "./UserRaisingModal";
import EventBus from "../event-bus";

import { styled } from "@egoist/vue-emotion";

const BtnAction = styled("button")`
  color: ${(props) => props.colorT};
  border-color: ${(props) => props.colorT};
  &:hover {
    background-color: ${(props) => props.colorT};
  }
`;

export default {
  name: "raising-chat-modal",
  data() {
    return {
      uuid: localStorage.getItem("user_id"),
      is_curador: false,
      showNewMessageButton: false,
      information: null,
      comments: null,
      showRaisingModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      maxStars: 5,
      filter: "all",
    };
  },
  components: {
    UserRaisingModal,
    BtnAction,
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    colorP: {
      required: true,
    },
    colorS: {
      required: true,
    },
    colorT: {
      required: true,
    },
  },
  mounted() {
    EventBus.$on("showChatModal", this.setData);
  },
  methods: {
    reset() {
      this.is_curador = false;
      this.showNewMessageButton = false;
      this.information = null;
      this.errors = {
        codeError: "Ha ocurrido un error",
      };
      this.showingError = false;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(data) {
      this.information = Object.assign({}, data);
      this.is_curador = this.information.is_curador;
      this.showNewMessageButton = this.information["showNewMessageButton"];
      if (this.information.menu == "LEVANTAMIENTO") {
        this.fetchCommentsRaising();
      } else {
        this.fetchCommentsProyects();
      }
    },
    fetchCommentsProyects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          `../apidev/projects/getComments`,
          {
            id: this.information.raising_id,
          },
          this.config
        )
        .then((response) => {
          this.comments = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchCommentsRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          `../apidev/levantamientos/getComments`,
          {
            id: this.information.raising_id,
          },
          this.config
        )
        .then((response) => {
          this.comments = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    updateStatusModal() {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", this.information);
    },
    fetchAllChat() {
      if (this.information.menu == "LEVANTAMIENTO") {
        this.fetchCommentsRaising();
      } else {
        this.fetchCommentsProyects();
      }
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
